"use strict";
require("angular-route");
function initRoutes(app) {
    /* @ngInject */
    app.config(function ($routeProvider) {
        $routeProvider
            .when("/:tenantId", {
            template: "<groups></groups>",
            resolve: {
                /* @ngInject */
                initData: function ($route, groupsInitService) {
                    return groupsInitService($route.current.params.tenantId);
                }
            }
        })
            .when("/:tenantId/assign-programs", {
            template: "<assign-programs></assign-programs>",
            resolve: {
                /* @ngInject */
                groups: function ($route, groupsService) {
                    return groupsService.getForAssignment($route.current.params.tenantId);
                },
                /* @ngInject */
                studyPrograms: function ($route, studyProgramsService) {
                    return studyProgramsService.getStudyPrograms($route.current.params.tenantId, true);
                },
                /* @ngInject */
                instructors: function ($route, instructorsService) {
                    return instructorsService($route.current.params.tenantId);
                }
            }
        })
            .when("/:tenantId/group-detail/:groupId", {
            template: "<group-detail></group-detail>",
            resolve: {
                /* @ngInject */
                group: function ($route, groupsService) {
                    return groupsService.calculateStudentGrade(groupsService.
                        getOne($route.current.params.groupId, $route.current.params.tenantId));
                },
                /* @ngInject */
                studyPrograms: function ($route, studyProgramsService) {
                    return studyProgramsService.getStudyPrograms($route.current.params.tenantId, true);
                },
                /* @ngInject */
                instructors: function ($route, instructorsService) {
                    return instructorsService($route.current.params.tenantId);
                }
            }
        })
            .when("/:tenantId/default-group-detail/:groupId", {
            template: "<default-group-detail></default-group-detail>",
            resolve: {
                /* @ngInject */
                group: function ($route, groupsService) {
                    return groupsService.calculateStudentGrade(groupsService.
                        getOne($route.current.params.groupId, undefined));
                },
                /* @ngInject */
                availableStudents: function ($route, studentsService) {
                    var defaultGrades = [];
                    if ($route.current.params.defaultGrades) {
                        $route.current.params.defaultGrades.split(",").forEach(function (value) {
                            var defaultGrade = Number(value);
                            if (!isNaN(defaultGrade)) {
                                defaultGrades.push(defaultGrade);
                            }
                        });
                    }
                    return studentsService.getByGrade($route.current.params.tenantId, defaultGrades);
                }
            }
        })
            .when("/:tenantId/manage-defaults", {
            template: "<manage-defaults></manage-defaults>",
            resolve: {
                // TODO this will likely change when current default prefs become available
                /* @ngInject */
                studyPrograms: function ($route, studyProgramsService) {
                    return studyProgramsService.getStudyPrograms($route.current.params.tenantId, true);
                },
                /* @ngInject */
                preference: function ($route, preferenceService, userSessionService) {
                    if (userSessionService.isDistrictMode()) {
                        return preferenceService.getInstitutionPreference(userSessionService.getDistrictTenantId());
                    }
                    else {
                        return preferenceService.getInstitutionPreference($route.current.params.tenantId);
                    }
                }
            }
        })
            .when("/:tenantId/set-ap-programs", {
            template: "<set-ap-programs></set-ap-programs>",
            resolve: {
                /* @ngInject */
                subscriptionStudyPrograms: function ($route, studyProgramsService) {
                    return studyProgramsService.getSubscriptionStudyPrograms($route.current.params.tenantId, true);
                }
            }
        })
            .otherwise({ redirectTo: "/" });
    });
}
exports.initRoutes = initRoutes;



/** WEBPACK FOOTER **
 ** ./app/app-routes/app.routes.ts
 **/